import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { PageParams } from 'src/app/core/models/page-params.model';
import { UserService } from 'src/app/core/services/user.service';
import { IProduct } from '../../../models/order-details.model';
import { ISaleOrder } from 'src/app/modules/sales-order-management/models/sale-order.interface';
import { SaleOrderService } from 'src/app/modules/sales-order-management/services/sale-order.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { IAvailableTypes } from 'src/app/core/models/available-types.interface';
import { ShipmentConsolStatus } from 'src/app/shared/enums/shipment-consol-status.enum';
import { FileStatus } from 'src/app/shared/enums/file-status.enum';
import { UploadFileService } from 'src/app/core/services/upload-file.service';
import { DeliveryStatusLabelPipe } from 'src/app/shared/pipes/delivery-status-label.pipe';
import {Router} from '@angular/router';
import { SelectionModel } from '@angular/cdk/collections';
import { ConsolidateShipmentService } from 'src/app/core/services/consolidate-shipments.service';
import {MatDialog} from '@angular/material/dialog';
import { ConfirmPopupDialog } from 'src/app/shared/popups/confirm-popup/confirm-popup.component';
import { deliveredStatuses } from 'src/app/core/constants.enum';
import {IParcelItem} from "../../../../sales-order-management/models/parcel-item";
import {
    formatPickupDaysRemaining,
    getPickupCountdownStatusClass,
    hasPickupMissingStatusAlert,
    countPickupMissed,
    countPickupWithinWindow,
    countReadyForPickupOrders,
    countSoInWarehouseMoreThanDays,
    getDaysInWarehouse,
    getSaleOrderOperationalStatusId,
} from 'src/app/shared/helpers/vintedgo-pickup-countdown.util';
import {
    ConsolidatedShipmentStatusGroup,
    filterConsolidatedStatusGroupOptions,
    getConsolidatedStatusGroupFilterOptions,
    getConsolidatedStatusLabel,
    getStatusIdsForGroups,
    IConsolidatedStatusGroupOption,
} from 'src/app/shared/helpers/consolidate-shipment-status-groups.util';

export enum ParcelStatus {
    Failure = 'failure',
    Created = 'created',
    Creating = 'creating',
}

@Component({
  selector: 'eci-consolidate-shipment-packages',
  templateUrl: './consolidate-shipment-packages.component.html',
  styleUrls: ['./consolidate-shipment-packages.component.scss']
})
export class ConsolidateShipmentPackagesComponent implements OnInit, OnChanges {

  pageParams: PageParams = new PageParams();
  @Input() summaryPage = false;
  @Input() hasError: boolean;
  @Input() isCreateMode: boolean;
  @Input() saleOrders: ISaleOrder[];
  @Input() availableTypes: IAvailableTypes;
  @Input() status: number;
  @Input() info: any;
  @Output() hasErrorChange = new EventEmitter<boolean>();
  public selection = new SelectionModel<any>(true, []);
  @Output() selectedOrders = new EventEmitter<any[]>();
  @Output() saleOrdersRemoved = new EventEmitter<void>();

  currentSort: Sort;
  showLoader: boolean = false;
  orderStatus: FormControl = new FormControl(null);
  searchorderStatus: FormControl = new FormControl('');
  private appliedStatusFilter: ConsolidatedShipmentStatusGroup[] | null = null;
  private readonly statusGroupOptions = getConsolidatedStatusGroupFilterOptions();
  private readonly deliveryStatusLabelPipe = new DeliveryStatusLabelPipe();
  ShipmentConsolStatus = ShipmentConsolStatus;
  ShipmentConsolStatusDraft: boolean = false;
  getIsSoDelivered(status): boolean {
    return deliveredStatuses.includes(Number(status));
  }

  /** Latest operational status from status history only (not legacy sale_orders.status). */
  getOrderOperationalStatus(order: ISaleOrder): number | null {
    return getSaleOrderOperationalStatusId(order);
  }

  pageChanged(e: PageParams): void {
    this.pageParams.pageIndex = e.pageIndex;
    this.pageParams.pageSize = e.pageSize;
    // this.getList(e.pageIndex + 1, e.pageSize);
  }

  constructor(
    public userSvc: UserService,
    private saleOrderSvc: SaleOrderService,
    private notify: NotificationService,
    private uploadFileSvc: UploadFileService,
    private router: Router,
    private consolShipmentSvc: ConsolidateShipmentService,
    private dialog: MatDialog,
  ) { }

  displayedColumns: string[] = [
   // 'donwloadDocuments',
    'select',
    'downloadParcelLabel',
    'parcelCount',
    'orderDate',
    'shopName',
    'marketplaceName',
    'marketplaceOrderId',
    'destination',
    'totalOrderVat',
    'carrier',
    'trackingNumber',
    'parcelWeight',
    'parcelHeight',
    'parcelWidth',
    'parcelDepth',
  ];
  dataSource: MatTableDataSource<IProduct>;

  ngOnInit(): void {
    if (!this.isCreateMode) {
      this.displayedColumns.push('daysInWarehouse');
      this.displayedColumns.push('pickupCountdown');
      this.displayedColumns.push('aftershipStatus');
    }
    this.applyDataSource();
    this.setStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.saleOrders && this.saleOrders) {
      this.applyDataSource();
      this.selection.clear();
      this.selectedOrders.emit([]);
    }
  }

  get filteredStatusGroupOptions(): IConsolidatedStatusGroupOption[] {
    return filterConsolidatedStatusGroupOptions(
      this.statusGroupOptions,
      this.searchorderStatus.value,
    );
  }

  get waitingForPickupCount(): number {
    return countReadyForPickupOrders(this.saleOrders);
  }

  get pickupWithinWindowCount(): number {
    return countPickupWithinWindow(this.saleOrders);
  }

  get pickupMissedCount(): number {
    return countPickupMissed(this.saleOrders);
  }

  get soInWarehouseMoreThan2DaysCount(): number {
    return countSoInWarehouseMoreThanDays(this.saleOrders);
  }

  search(): void {
    const selected = this.orderStatus.value;
    this.appliedStatusFilter = Array.isArray(selected) && selected.length > 0
      ? selected as ConsolidatedShipmentStatusGroup[]
      : null;
    this.applyDataSource();
    this.selection.clear();
    this.selectedOrders.emit([]);
  }

  getStatusDisplayLabel(status: number | null | undefined): string {
    const groupedLabel = getConsolidatedStatusLabel(status);
    if (groupedLabel) {
      return groupedLabel;
    }

    return this.deliveryStatusLabelPipe.transform(status);
  }

  getOrderStatusDisplayLabel(order: ISaleOrder): string {
    return this.getStatusDisplayLabel(this.getOrderOperationalStatus(order));
  }

  exportLabelsToExcel(): void {
    if (!this.info?.id) {
      return;
    }

    const filteredOrders = this.getFilteredSaleOrders();
    if (!filteredOrders.length) {
      this.notify.showError('No sale orders to export');
      return;
    }

    this.showLoader = true;
    const saleOrderIds = filteredOrders.map((order) => order.id);

    this.consolShipmentSvc.exportLabels(this.info.id, saleOrderIds).subscribe({
      next: () => {
        this.showLoader = false;
      },
      error: async (err) => {
        this.showLoader = false;
        if (err?.error instanceof Blob) {
          try {
            const text = await err.error.text();
            const json = JSON.parse(text);
            this.notify.showError(json?.message || 'Failed to export labels');
            return;
          } catch {
            // fall through to generic error
          }
        }
        this.notify.showError('Failed to export labels');
      },
    });
  }

  getPickupDaysLabel(order: ISaleOrder): string {
    return formatPickupDaysRemaining(this.getOrderOperationalStatus(order), order.readyForPickupDate);
  }

  getDaysInWarehouseLabel(order: ISaleOrder): string {
    const days = getDaysInWarehouse(order);
    return days == null ? '-' : String(days);
  }

  getPickupStatusClass(order: ISaleOrder): string {
    return getPickupCountdownStatusClass(this.getOrderOperationalStatus(order), order.readyForPickupDate);
  }

  isPickupMissingStatus(order: ISaleOrder): boolean {
    return hasPickupMissingStatusAlert({
      status: this.getOrderOperationalStatus(order),
      readyForPickupDate: order.readyForPickupDate,
    });
  }

  private applyDataSource(): void {
    const rows = this.getFilteredSaleOrders();
    this.dataSource = new MatTableDataSource<IProduct>(rows);
  }

  private getFilteredSaleOrders(): ISaleOrder[] {
    const orders = this.saleOrders ?? [];
    if (!this.appliedStatusFilter?.length) {
      return orders;
    }

    const allowedStatusIds = getStatusIdsForGroups(this.appliedStatusFilter);
    return orders.filter((order) => allowedStatusIds.has(Number(this.getOrderOperationalStatus(order))));
  }

  sortData(sort: Sort): void {
    const data = this.getFilteredSaleOrders().slice();
    if (!sort.active || sort.direction === '') {
      this.dataSource = new MatTableDataSource<IProduct>(this.dataSource.data);
      return;
    }

    this.localSort(sort, data);
    this.currentSort = sort;
  }

  localSort(sort: Sort, data: any): void {
    this.dataSource = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'orderDate': return compare(a?.orderDate, b?.orderDate, isAsc);
        case 'shopName': return compare(a?.marketplace?.saleOrderMarketplace?.shopName,
            b?.marketplace?.saleOrderMarketplace?.shopName, isAsc);
        case 'marketplaceName': return compare(a?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name,
            b?.marketplace?.saleOrderMarketplace?.marketplaceInfo?.name, isAsc);
        case 'marketplaceOrderId': return compare(a?.marketplace?.marketplaceOrderId,
            b?.marketplace?.marketplaceOrderId, isAsc);
        default: return 0;
      }
    });

    this.dataSource = new MatTableDataSource<IProduct>(this.dataSource.data);
  }

  updateTrackingNumber(element): void {
    this.saleOrderSvc.changeTrackingNumber({
      id: element.id,
      trackingNumber: element.shipmentTrackingNumber
    }).subscribe(value => {
      if (value?.code === 4003) {
        this.notify.showError(value?.message);
      } else {
        this.notify.showSuccessMessage('Updated successfully');
      }
    }, err => {
      this.notify.showError('Something went wrong');
      console.log("ERROR", err);
    })
  }

  downloadDoc(element): void {
    this.saleOrderSvc.downloadFile(element?.id, element?.orderDocuments[0]?.id);
  }

  downloadShow(status: number): boolean {
    return status === FileStatus.UPLOADED;
  }

  uploadShow(status: number): boolean {
    return status == FileStatus.PENDING;
  }

  get documentFileTypes(): string[] {
    return [...this.uploadFileSvc.textFileFormats, ...this.uploadFileSvc.fileFormats]
  }


  uploadDoc(el: { saleOrderId: number, id: number, e: any, file: any }): void {
    const files = el.e.dataTransfer ? el.e.dataTransfer.files : el.e.target.files;

    this.saleOrderSvc.uploadFile(files, el.saleOrderId, el.id);

    this.saleOrders.find(saleOrder => saleOrder.id === el.saleOrderId).orderDocuments.find(doc => doc.id === el.id).status = FileStatus.UPLOADED;
  }

  get isShowStatus(): boolean {
    return Number(this.status) === ShipmentConsolStatus.CUSTOMS_CLEARED;
  }

  navigateTo(id){
  }

  /** Open the exact sale order for this row (by SO id — same as sales-order list). */
  navigateToSO(order: ISaleOrder): void {
    if (!order?.id) {
      return;
    }
    const url = this.router.createUrlTree(['/sales-order-management/order-details', order.id]).toString();
    window.open(url, '_blank');
  }

  removeSaleOrders() {
    const selectedItems = this.selection.selected;

    if (selectedItems.length === 0) {
      return;
    }

    const selectedIds = selectedItems.map(item => item.id);

    if (selectedIds && selectedIds?.length > 0) {
      const dialogRef = this.dialog.open(ConfirmPopupDialog);
      dialogRef.componentInstance.message = 'Are you sure you want to remove the selected sale order(s)?';
      dialogRef.componentInstance.rightBtnText = 'Remove';
      dialogRef.afterClosed().subscribe(value => {
        if (!value) return;
        this.consolShipmentSvc.removeSaleOrders(selectedIds, this.info?.id).subscribe((res) => {
          if (!res) return;
          this.notify.showSuccessMessage("Sale Order(s) removed successfully");
          this.saleOrdersRemoved.emit();
        }, () => {
          this.notify.showError("Something went wrong");
        });
      });
    }
  }

  setStatus() {
    if (this.status === ShipmentConsolStatus.DRAFT) {
      this.ShipmentConsolStatusDraft = true;
      if (!this.displayedColumns.includes('select')) {
        this.displayedColumns.unshift('select');
      }
    }
  }

    public canHandleLabel(
        order: ISaleOrder,
        type: 'show' | 'create' | 'refresh'
    ): boolean {
        if (!order.parcel?.length) return false;
        switch (type) {
            case 'show':
                return order.parcel.some(p => p.labelStatus === ParcelStatus.Created);
            case 'create':
                return order.parcel.some(p =>
                    (!p.labelStatus &&
                    p.labelStatus !== ParcelStatus.Created &&
                    p.labelStatus !== ParcelStatus.Creating ) ||
                    p.labelStatus == ParcelStatus.Failure);
            case 'refresh':
                return order.parcel.some(p => p.labelStatus === ParcelStatus.Creating);
        }
    }

    public viewParcelLabel(order: ISaleOrder): void {
      this.saleOrderSvc.downloadParcelLabel([order.id]);
    }

    public canUploadLabel(order: ISaleOrder): boolean {
        return this.userSvc.isAdmin && !!order.parcel?.length;
    }

    public uploadParcelLabel(order: ISaleOrder, event: Event): void {
        const input = event.target as HTMLInputElement;
        const file = input.files?.[0];
        if (!file || !order.parcel?.length) {
            return;
        }

        const parcelId = order.parcel[0].id;
        this.saleOrderSvc.uploadParcelLabel(parcelId, file).subscribe({
            next: (res) => {
                this.updateParcel(order.id, parcelId, { labelStatus: res.data?.labelStatus || 'created' });
                this.notify.showSuccessMessage('Label uploaded successfully');
                input.value = '';
            },
            error: () => {
                this.notify.showError('Label upload failed');
                input.value = '';
            },
        });
    }

    public createLabel(order: ISaleOrder): void {
        this.saleOrderSvc.createLabels([order.id])
            .subscribe({
            next: (res) => {
                res.data.forEach((label) => {
                    this.updateParcel(label.saleOrderId, label.parcelId, {
                        labelStatus: label.labelStatus });
                });
            },
            error: (error) => {
                this.notify.showError('Label can`t be created due to some error');
            },
        });
    }

    private updateParcel(orderId: number, parcelId: string | number | null, update: Partial<IParcelItem>): void {
        const order = this.saleOrders.find((o) => o.id === orderId);
        if (!order?.parcel?.length) {
            return;
        }
        if (parcelId === null) {
            order.parcel.forEach((p) => Object.assign(p, update));
            return;
        }
        const parcel = order.parcel.find((p) => String(p.id) === String(parcelId));
        if (parcel) {
            Object.assign(parcel, update);
        }
    }

    public refreshParcelLabel(order: ISaleOrder): void {
        this.saleOrderSvc.refreshLabels([order.id])
            .subscribe({
                next: (res) => {
                    res.data.forEach((label) => {
                        this.updateParcel(label.saleOrderId, label.parcelId, {
                            labelStatus: label.labelStatus });
                    });
                },
                error: (error) => {
                    this.notify.showError('Label can`t be updated due to some error');
                },
            });
    }

    public updateSelection($event: SelectionModel<any>): void {
        this.selection = $event;
        this.selectedOrders.emit($event.selected);
    }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
